"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var react_toastify_1 = require("react-toastify");
var react_query_1 = require("react-query");
var styles_1 = require("@mui/material/styles");
require("react-toastify/dist/ReactToastify.css");
var App_1 = __importDefault(require("./App"));
var ContentContext_1 = require("./context/ContentContext");
var GlobalContext_1 = require("./context/GlobalContext");
var SearchVacanciesContext_1 = require("./context/SearchVacanciesContext");
var UserContext_1 = require("./context/UserContext");
var NotificationContext_1 = require("./context/NotificationContext");
var BookmarkedContext_1 = require("./context/BookmarkedContext");
var StickyContext_1 = require("./context/StickyContext");
var ApplyVacancyContext_1 = require("./context/ApplyVacancyContext");
var MessageContext_1 = require("./context/MessageContext");
var CurrentConnectionContext_1 = require("./context/CurrentConnectionContext");
var theme = (0, styles_1.createTheme)({
    palette: {
        primary: {
            main: '#ff4f6b',
            dark: '#B5001D',
        },
        secondary: {
            main: '#B5001D',
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: '50px',
                },
            },
        },
    },
    typography: {
        fontFamily: ['TTNorms', 'Roboto', 'Helvetica', 'Arial', 'sans-serif'].join(','),
    },
    spacing: function (factor) { return "".concat(0.25 * factor, "rem"); },
});
var Root = /** @class */ (function (_super) {
    __extends(Root, _super);
    function Root() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.queryClient = new react_query_1.QueryClient();
        return _this;
    }
    Root.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)(styles_1.ThemeProvider, __assign({ theme: theme }, { children: (0, jsx_runtime_1.jsx)(react_query_1.QueryClientProvider, __assign({ client: this.queryClient }, { children: (0, jsx_runtime_1.jsx)(GlobalContext_1.GlobalProvider, { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.BrowserRouter, { children: (0, jsx_runtime_1.jsx)(StickyContext_1.StickyProvider, { children: (0, jsx_runtime_1.jsx)(ApplyVacancyContext_1.ApplyVacancyProvider, { children: (0, jsx_runtime_1.jsx)(SearchVacanciesContext_1.SearchVacanciesProvider, { children: (0, jsx_runtime_1.jsx)(UserContext_1.UserProvider, { children: (0, jsx_runtime_1.jsx)(BookmarkedContext_1.BookmarkedProvider, { children: (0, jsx_runtime_1.jsx)(MessageContext_1.MessageProvider, { children: (0, jsx_runtime_1.jsx)(NotificationContext_1.NotificationProvider, { children: (0, jsx_runtime_1.jsx)(CurrentConnectionContext_1.CurrentConnectionProvider, { children: (0, jsx_runtime_1.jsxs)(ContentContext_1.ContentProvider, { children: [(0, jsx_runtime_1.jsx)(App_1.default, {}), (0, jsx_runtime_1.jsx)(react_toastify_1.ToastContainer, { theme: "colored" })] }) }) }) }) }) }) }) }) }) }) }) })) })));
    };
    return Root;
}(react_1.Component));
exports.default = Root;
